export function slugify(input: string, maxLen = 48): string {
  return input
    .toLowerCase()
    .trim()
    .replace(/[\'’]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, maxLen);
}

